import React from "react";
import {useTranslation} from "react-i18next";
import {passwordRules} from "../../utils/passwordRules";
import {getPasswordStrength} from "../../utils/passwordStrength";

interface Props {
    password: string;
}

export default function PasswordRules({password}: Props) {
    const {t} = useTranslation();

    if (!password) return null;

    const strength = getPasswordStrength(password);

    return (
        <div className={`password-rules-container strength-${strength}`}>
            <div className="password-strength-indicator">
                <span className="label">{t("password.strength")}</span>
                <span className={`value ${strength}`}>
                    {t(`password.strengthLevel.${strength}`)}
                </span>
            </div>

            <div className="password-checklist">
                {passwordRules.map(rule => {
                    const ok = rule.test(password);
                    return (
                        <div key={rule.id} className="password-rule">
                            <span className={ok ? "rule-icon ok" : "rule-icon fail"}>
                                {ok ? "✔" : "✖"}
                            </span>
                            <span className={ok ? "rule-text ok" : "rule-text fail"}>
                                {t(rule.label)}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}